import React, { Component } from "react";
import PropTypes from "prop-types";
import { Card, Form, Button, Row, Col, Alert } from "react-bootstrap";
import api from "../../services/api";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import { withRouter } from "../../common/with-router";
import { FaCheck, FaEye, FaFilePdf } from "react-icons/fa";
import Select from "react-select";
import AsyncSelect from "react-select/async";
import { TIPOS_USUARIOS_LISTA } from "../../common/utils";

const MySwal = withReactContent(Swal);

class TermosPlataformaEdit extends Component {
  constructor(props) {
    super(props);
    this.handleChange = this.handleChange.bind(this);
    this.handleSelectChange = this.handleSelectChange.bind(this);
    this.handleFileChange = this.handleFileChange.bind(this);
    this.enviaRegistro = this.enviaRegistro.bind(this);
    this.handleFormSubmit = this.handleFormSubmit.bind(this);

    this.fileInputRef = React.createRef();

    this.state = {
      titulo: "",
      slug: "",
      tiposSelecionados: [],
      arquivoPdf: null,
      arquivoPdfUrlAtual: null,
      excluirPdfAtual: false,

      categoria: "",
      // Subcategoria opcional. Sem ela, o termo atinge todos os multiprofissionais.
      // Serve pra separar TCLE de nutri vs psicologa vs farmaceutica no mesmo programa.
      categoriaMultiprofissionalId: "",
      categoriasMultiOpcoes: [],
      programasSelecionados: [],

      erroLoadRegistro: "",
      termo_id: "",
      titulo_pagina: "",
      isEditing: false,
      loading: false,
      is_active: false,

      versaoAtual: 1,

      tituloHelper: "",
      slugHelper: "",
      tiposSelecionadosHelper: "",
      arquivoPdfHelper: "",
    };
  }

  componentDidMount() {
    this.carregarCategoriasMulti();
    const id = this.props.router.params.id;

    if (id) {
      // Modo Edição
      this.setState({
        termo_id: id,
        titulo_pagina: "Editando Termo/Versão",
        isEditing: true,
        loading: true,
        erroLoadRegistro: "",
      });

      api
        .get(`/termos-plataforma/admin/${id}/`)
        .then((response) => {
          const dados = response.data;
          const tiposAtuais = dados.tipos_usuarios
            .map((slug) =>
              TIPOS_USUARIOS_LISTA.find((opt) => opt.value === slug)
            )
            .filter((opt) => opt !== undefined);

          this.setState({
            erroLoadRegistro: "",
            titulo: dados.titulo,
            slug: dados.slug,
            tiposSelecionados: tiposAtuais,
            arquivoPdfUrlAtual: dados.arquivo_pdf_url,
            is_active: dados.is_active,
            versaoAtual: dados.versao,
            categoria: dados.categoria ?? "",
            categoriaMultiprofissionalId: dados.categoria_multiprofissional ?? "",
            programasSelecionados: (dados.dados_programa || []).map((p) => ({
              value: p.id,
              label: p.nome,
            })),
            loading: false,
          });
        })
        .catch((error) => {
          let erro_msg = "Erro ao consultar o termo, tente novamente";
          if (error.response && error.response.status === 500) {
            erro_msg = "Servidor indisponível no momento, tente novamente";
          }
          this.setState({
            loading: false,
            erroLoadRegistro: erro_msg,
          });
        });
    } else {
      // Modo Criação
      this.setState({
        termo_id: "",
        titulo_pagina: "Adicionar Novo Termo/Versão",
        isEditing: false,
        loading: false,
        erroLoadRegistro: "",
      });
    }
  }

  enviaRegistro = () => {
    const formData = new FormData();

    this.setState({
      loading: true,
      tituloHelper: "",
      slugHelper: "",
      tiposSelecionadosHelper: "",
      arquivoPdfHelper: "",
    });

    formData.append("titulo", this.state.titulo);
    formData.append("slug", this.state.slug);
    formData.append(
      "tipos_usuarios",
      JSON.stringify(this.state.tiposSelecionados.map((t) => t.value))
    );
    if (this.state.categoria) {
      formData.append("categoria", this.state.categoria);
    }
    // Subcategoria multiprofissional so faz sentido quando categoria='multiprofissionais'.
    // Vazio limpa (FK opcional).
    if (this.state.categoria === "multiprofissionais" && this.state.categoriaMultiprofissionalId) {
      formData.append("categoria_multiprofissional", this.state.categoriaMultiprofissionalId);
    } else {
      formData.append("categoria_multiprofissional", "");
    }
    formData.append(
      "programas",
      JSON.stringify(this.state.programasSelecionados.map((p) => p.value))
    );

    let metodo;
    let url;
    const hasNewFile = this.state.arquivoPdf !== null;

    // Se o usuário anexou um novo PDF, é sempre um POST (criar nova versão)
    if (hasNewFile) {
      formData.append("arquivo_pdf", this.state.arquivoPdf);
      metodo = "post";
      url = "/termos-plataforma/admin/"; // URL de Criação
    } 
    // Se for um novo termo (não edição)
    else if (!this.state.isEditing) {
      metodo = "post";
      url = "/termos-plataforma/admin/";
    }
    // Se for edição, SEM novo PDF
    else {
      metodo = "put"; // Atualiza os metadados da versão existente
      url = `/termos-plataforma/admin/${this.state.termo_id}/`;
      
      if (this.state.excluirPdfAtual) {
          // (Não é ideal excluir o PDF de uma versão ativa, mas o backend permite)
          formData.append("excluir_pdf", "true");
      }
    }

    api({
      method: metodo,
      url: url,
      data: formData,
    })
      .then((response) => {
        const textSwal = (metodo === 'put')
          ? "Termo atualizado com sucesso"
          : "Nova versão cadastrada com sucesso";

        MySwal.fire({
          title: <p>{textSwal}</p>,
          icon: "success",
          showCloseButton: true,
        });

        this.setState({ loading: false });

        // Se criou um novo (POST), redireciona para a lista
        if (metodo === 'post') {
          this.props.router.navigate("/termos-plataforma");
        } else {
          // Se atualizou (PUT), apenas limpa os campos de arquivo
          this.setState({
            arquivoPdf: null,
            excluirPdfAtual: false,
            arquivoPdfUrlAtual: response.data.arquivo_pdf_url,
          });
          if (this.fileInputRef.current) {
            this.fileInputRef.current.value = "";
          }
          this.props.router.navigate("/termos-plataforma");
        }
      })
      .catch((error) => {
        let erro_msg =
          "Erro ao salvar o termo, verifique os campos e tente novamente";

        if (error.response && error.response.status === 500) {
          erro_msg = "Servidor indisponível no momento";
        } else if (error.response && error.response.status === 400) {
          const campos = error.response.data;

          for (let key in campos) {
            var value = Array.isArray(campos[key])
              ? campos[key].join(" ")
              : campos[key];

            if (key === "titulo") {
              this.setState({ tituloHelper: value });
            }
            if (key === "slug") {
              this.setState({ slugHelper: value });
            }
            if (key === "tipos_usuarios") {
              this.setState({ tiposSelecionadosHelper: value });
            }
            if (key === "arquivo_pdf") {
              this.setState({ arquivoPdfHelper: value });
            }
          }
        }

        MySwal.fire({
          icon: "error",
          showCloseButton: true,
          title: <p>{erro_msg}</p>,
        });

        this.setState({
          loading: false,
        });
      });
  };

  handleFormSubmit = (e) => {
    e.preventDefault();
    const hasNewFile = this.state.arquivoPdf !== null;

    // Se for edição E anexou um novo arquivo, mostra o Swal
    if (this.state.isEditing && hasNewFile) {
        MySwal.fire({
            title: 'Criar Nova Versão?',
            text: `Você anexou um novo PDF. Isso irá desativar esta versão (v${this.state.versaoAtual}) e criar uma nova (v${this.state.versaoAtual + 1}). Os usuários terão que aceitar o novo termo. Deseja continuar?`,
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Sim, criar nova versão!',
            cancelButtonText: 'Cancelar'
        }).then((result) => {
            if (result.isConfirmed) {
                this.enviaRegistro();
            }
        });
    } else {
        this.enviaRegistro();
    }
  };

  carregarProgramas = async (inputValue) => {
    try {
      const response = await api.get(`/programas/?nome=${inputValue}`);
      return response.data.results.map((programa) => ({
        value: programa.id,
        label: programa.nome,
      }));
    } catch (error) {
      return [];
    }
  };

  carregarCategoriasMulti = async () => {
    try {
      const response = await api.get(`/profissionais/categorias-multiprofissionais/`);
      const results = response.data.results || response.data || [];
      this.setState({ categoriasMultiOpcoes: results });
    } catch (error) {
      this.setState({ categoriasMultiOpcoes: [] });
    }
  };

  handleChange = (e) => {
    const { name, value } = e.target;
    if (name === "slug") {
      this.setState({
        [name]: value.toLowerCase().replace(/[^a-z0-9-]+/g, ""),
      });
    } else {
      this.setState({ [name]: value });
    }
  };

  handleSelectChange = (selectedOptions) => {
    this.setState({ tiposSelecionados: selectedOptions || [] });
  };

  handleProgramasChange = (selectedOptions) => {
    this.setState({ programasSelecionados: selectedOptions || [] });
  };

  handleFileChange = (event) => {
    if (event.target.files && event.target.files[0]) {
      if (event.target.files[0].type === "application/pdf") {
        this.setState({
          arquivoPdf: event.target.files[0],
          excluirPdfAtual: false,
          arquivoPdfHelper: "",
        });
      } else {
        this.setState({
          arquivoPdf: null,
          arquivoPdfHelper: "Por favor, selecione um arquivo PDF.",
        });
        if (this.fileInputRef.current) this.fileInputRef.current.value = "";
      }
    } else {
      this.setState({ arquivoPdf: null });
    }
  };

  render() {
    if (this.state.isEditing && !this.state.is_active) {
      return (
        <Alert variant="warning">
          Termos inativos (versões antigas) não podem ser editados.
          <Button
            variant="link"
            onClick={() => this.props.router.navigate("/termos-plataforma")}
          >
            Voltar para a lista
          </Button>
        </Alert>
      );
    }

    const hasNewFile = this.state.arquivoPdf !== null;
    const buttonText = this.state.isEditing ? 
                       (hasNewFile ? "Salvar Nova Versão" : "Salvar Alterações") : 
                       "Salvar";

    return (
      <div>
        <Row className="align-items-center">
          <Col sm={6} lg={6}>
            <h4 className="page-title">{this.state.titulo_pagina}</h4>
          </Col>
        </Row>
        <Card className="cardDestaque">
          <Card.Body>
            <Form onSubmit={this.handleFormSubmit}>
              <h4>Dados do Termo</h4>
              <Row>
                <Col sm={8} xs={12}>
                  <Form.Group className="mb-3">
                    <Form.Label>Título*</Form.Label>
                    <Form.Control
                      type="text"
                      name="titulo"
                      required
                      placeholder="Ex: Política de Privacidade HNS v2"
                      value={this.state.titulo}
                      onChange={this.handleChange}
                    />
                    <Form.Text className="text-danger">
                      {this.state.tituloHelper}
                    </Form.Text>
                  </Form.Group>
                </Col>
                <Col sm={4} xs={12}>
                  <Form.Group className="mb-3">
                    <Form.Label>Slug*</Form.Label>
                    <Form.Control
                      type="text"
                      name="slug"
                      required
                      placeholder="ex: politica-privacidade"
                      value={this.state.slug}
                      onChange={this.handleChange}
                      disabled={this.state.isEditing}
                    />
                    <Form.Text muted>
                      {this.state.isEditing
                        ? "O slug não pode ser alterado na edição."
                        : "Identificador único."}
                    </Form.Text>
                    <Form.Text className="text-danger">
                      {this.state.slugHelper}
                    </Form.Text>
                  </Form.Group>
                </Col>
              </Row>
              <Row>
                <Col sm={6} xs={12}>
                  <Form.Group className="mb-3">
                    <Form.Label>Categoria</Form.Label>
                    <Form.Control
                      type="text"
                      name="categoria"
                      placeholder="Categoria"
                      value={this.state.categoria}
                      onChange={this.handleChange}
                    />
                    <Form.Text muted>
                      Ex.: <code>medicos</code>, <code>multiprofissionais</code>, <code>laboratorio_diagnostico</code>.
                    </Form.Text>
                  </Form.Group>
                </Col>
                {this.state.categoria === "multiprofissionais" && (
                  <Col sm={6} xs={12}>
                    <Form.Group className="mb-3">
                      <Form.Label>Subcategoria multiprofissional</Form.Label>
                      <Form.Select
                        name="categoriaMultiprofissionalId"
                        value={this.state.categoriaMultiprofissionalId || ""}
                        onChange={this.handleChange}
                      >
                        <option value="">Todas (nutri, psicóloga, etc.)</option>
                        {this.state.categoriasMultiOpcoes.map((c) => (
                          <option key={c.id} value={c.id}>
                            {c.nome}
                          </option>
                        ))}
                      </Form.Select>
                      <Form.Text muted>
                        Restringe o termo a uma subcategoria (ex.: só Nutricionista). Vazio = todos os multiprofissionais.
                      </Form.Text>
                    </Form.Group>
                  </Col>
                )}
              </Row>
              <Row>
                <Col sm={12} xs={12}>
                  <Form.Group className="mb-3">
                    <Form.Label>Programas</Form.Label>
                    <AsyncSelect
                      isMulti
                      cacheOptions
                      loadOptions={this.carregarProgramas}
                      defaultOptions
                      name="programas"
                      placeholder="Buscar programas..."
                      noOptionsMessage={() => "Nenhum programa encontrado"}
                      onChange={this.handleProgramasChange}
                      value={this.state.programasSelecionados}
                      closeMenuOnSelect={false}
                    />
                  </Form.Group>
                </Col>
              </Row>
              <Row>
                <Col sm={12} xs={12}>
                  <Form.Group className="mb-3">
                    <Form.Label>Aplicável aos Tipos de Usuário*</Form.Label>
                    <Select
                      isMulti
                      options={TIPOS_USUARIOS_LISTA}
                      value={this.state.tiposSelecionados}
                      onChange={this.handleSelectChange}
                      placeholder="Selecione os tipos..."
                      closeMenuOnSelect={false}
                    />
                    <Form.Text className="text-danger">
                      {this.state.tiposSelecionadosHelper}
                    </Form.Text>
                  </Form.Group>
                </Col>
              </Row>
              <Row>
                <Col sm={12} xs={12}>
                  <Form.Group className="mb-3">
                    <Form.Label>
                      {this.state.isEditing
                        ? "Substituir PDF (Opcional - Gera Nova Versão)"
                        : "Arquivo PDF*"}
                    </Form.Label>

                    {this.state.isEditing &&
                      this.state.arquivoPdfUrlAtual &&
                      !this.state.arquivoPdf &&
                      !this.state.excluirPdfAtual && (
                        <div className="mb-2">
                          <small>Arquivo atual:</small>{" "}
                          <Button
                            variant="link"
                            size="sm"
                            href={this.state.arquivoPdfUrlAtual}
                            target="_blank"
                          >
                            <FaEye /> Ver PDF Atual (v{this.state.versaoAtual})
                          </Button>
                        </div>
                      )}
                    
                    <Form.Control
                      type="file"
                      accept="application/pdf"
                      onChange={this.handleFileChange}
                      ref={this.fileInputRef}
                      required={!this.state.isEditing}
                    />

                    {this.state.arquivoPdf && (
                      <div className="mt-1 text-success small">
                        <FaFilePdf /> Novo arquivo selecionado:{" "}
                        {this.state.arquivoPdf.name}
                        <Button
                          variant="link"
                          size="sm"
                          className="text-danger"
                          onClick={() => {
                            this.setState({ arquivoPdf: null });
                            if (this.fileInputRef.current)
                              this.fileInputRef.current.value = "";
                          }}
                        >
                          Remover
                        </Button>
                      </div>
                    )}
                    <Form.Text muted>
                      {this.state.isEditing
                        ? "Para criar uma nova versão (v" + (this.state.versaoAtual + 1) + "), anexe um novo PDF."
                        : "Selecione o arquivo PDF."}
                    </Form.Text>
                    <Form.Text className="text-danger">
                      {this.state.arquivoPdfHelper}
                    </Form.Text>
                  </Form.Group>
                </Col>
              </Row>

              {this.state.erroLoadRegistro ? (
                <Alert variant="warning">{this.state.erroLoadRegistro}</Alert>
              ) : (
                ""
              )}

              <Button
                variant="success"
                type="submit"
                className="btn-submit mt-3"
                disabled={this.state.loading}
              >
                {this.state.loading ? (
                  <span className="spinner-border spinner-border-sm"></span>
                ) : (
                  <>
                    <FaCheck className="me-1" /> {buttonText}
                  </>
                )}
              </Button>
            </Form>
          </Card.Body>
        </Card>
      </div>
    );
  }
}

TermosPlataformaEdit.propTypes = {
  router: PropTypes.object.isRequired,
};

export default withRouter(TermosPlataformaEdit);